export default __webpack_public_path__ + "static/media/Parent_Illustrations-01.920d3495.svg";